<!--
	NotFoundPage.svelte
-->

<script>
	import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';

    // TCARE components
    import {AccountStore} from "../../common/account";
    import PageBanner from '../../components/common/PageBanner.svelte';

    onMount(() => {
        if (!$AccountStore?.isLoggedIn) {
            push('/');
        }
    })

</script>

<style>
</style>

<div class="page-content not-found-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>
    <PageBanner title="Page not found"/>
    <div class="spacer-h-25"></div>
</div>

